const xNavbarSlider_custom = (id) => ({
    maxWidth: 0,
    splideInstance: null,
    isSplideInitialized: false,
    splideEl: null,
    listEl: null,

    init() {
      let eleContentMaxWidth = document.getElementById('contentMaxWidth-' + id);
      this.maxWidth = eleContentMaxWidth ? eleContentMaxWidth.parentElement.clientWidth : parseInt(eleContentMaxWidth.value) || 0;

      this.$nextTick(() => {
        this.splideEl = this.$el.querySelector('.x-splide');
        this.listEl = this.splideEl ? this.splideEl.querySelector('.ot-navigation-bar') : null;

        if (!this.splideEl || !this.listEl) {
          return;
        }

        this.checkSliderVisibility(this.listEl.scrollWidth);

        window.addEventListener(
          'resize',
          this.debounce(() => {
            this.checkSliderVisibility(this.listEl.scrollWidth);
          }, 200)
        );
      });
    },

    checkSliderVisibility(contentWidth) {
      const windowWidth = window.innerWidth -70;
      if (
        contentWidth > this.maxWidth ||
        (windowWidth < this.maxWidth && contentWidth > windowWidth)
      ) {
        this.showSlider();
      } else {
        this.hideSlider();
      }
    },

    showSlider() {
      if (!this.isSplideInitialized) {
        this.splideInstance = Alpine.store('otsb_xSplide').load(this.splideEl, {
          speed: 1000,
          pagination: false,
          autoWidth: true,
          mediaQuery: 'min',
          updateOnMove: true,
          omitEnd  : true,
          focus    : 0,
          drag: true,
          arrows: false,
          classes: {
            arrows: 'splide__arrows',
          }
        });
        this.splideEl.splideInstance = this.splideInstance;
        this.isSplideInitialized = true;
      }
      this.splideEl.classList.remove('hide_otsb_slider_nav');
    },

    hideSlider() {
      if (this.isSplideInitialized && this.splideInstance) {
        this.splideInstance.destroy();
        this.splideEl.splideInstance = null;
        this.splideInstance = null;
        this.isSplideInitialized = false;
      }
      this.splideEl.classList.add('hide_otsb_slider_nav');
    },

    debounce(func, wait) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }
});

if (!window.otsb.loadedScript.includes('otsb-navigation-bar.js')) {
  window.otsb.loadedScript.push('otsb-navigation-bar.js');
    document.addEventListener('alpine:init', () => {
      Alpine.data('xNavbarSlider_custom', xNavbarSlider_custom);
    });
}
